// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"812b4601","977":"98ebaca6"}[chunkId] + ".chunk.js";
};